import config from '../../../tailwind.config';

export default config.theme.screens;
